var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8849_73514",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8849_73514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1665 44.6455L20.6215 25.113C18.8215 25.5543 17.1832 26.2503 15.7065 27.201C14.2298 28.1516 12.9288 29.1985 11.8035 30.3415L8.45 27C9.66733 25.7826 10.9203 24.7113 12.209 23.786C13.498 22.8606 15.0512 22.0313 16.8685 21.298L11.5215 15.963C9.96283 16.7376 8.4995 17.638 7.1315 18.664C5.7635 19.6903 4.50017 20.7661 3.3415 21.8915L0 18.55C1.176 17.3406 2.44333 16.2046 3.802 15.142C5.16067 14.0793 6.53683 13.1725 7.9305 12.4215L3.3545 7.84547L5.6 5.59998L42.4 42.4L40.1665 44.6455ZM24 41.65C22.8 41.65 21.75 41.2 20.85 40.3C19.95 39.4 19.5 38.35 19.5 37.15C19.5 35.95 19.95 34.9 20.85 34C21.75 33.1 22.8 32.65 24 32.65C25.2 32.65 26.25 33.1 27.15 34C28.05 34.9 28.5 35.95 28.5 37.15C28.5 38.35 28.05 39.4 27.15 40.3C26.25 41.2 25.2 41.65 24 41.65ZM36.4955 30.0545C35.4035 28.9958 34.4095 28.1415 33.5135 27.4915C32.6175 26.8415 31.4735 26.2076 30.0815 25.59L24.539 20.048C27.674 20.1383 30.4278 20.7961 32.8005 22.0215C35.1735 23.2471 37.4233 24.9066 39.55 27L36.4955 30.0545ZM44.6585 21.8915C41.7252 19.1151 38.5428 16.9016 35.1115 15.251C31.6798 13.6003 27.976 12.775 24 12.775C22.8463 12.775 21.7387 12.848 20.677 12.994C19.6157 13.14 18.7335 13.3343 18.0305 13.577L14.1055 9.65197C15.5722 9.11864 17.1378 8.70998 18.8025 8.42598C20.4675 8.14198 22.2 7.99998 24 7.99998C28.6667 7.99998 33.0543 8.96664 37.163 10.9C41.2717 12.8333 44.884 15.3873 48 18.562L44.6585 21.8915Z",
    fill: "#FF655A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/wifi_off.5fea82a77ee9f0256111f91e3d211daf.svg";
export { ForwardRef as ReactComponent };